/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import Box from '@material-ui/core/Box';

import SumsubWebSdk from '@sumsub/websdk-react'

import LoadingComponent from 'components/loading';
import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import MandatoryFormFieldsComponent from 'components/form/mandatory';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';

import RegisterService from 'services/registerService';
import { handleApiFormResponse } from 'lib/forms';

import NotificationHelper from 'lib/notifications';

type SubscriptionTabSumSubComponentProps = {
  activeCompanyId: number;
  successHandler: () => void;
}

type SubscriptionTabSumSubComponentState = {
  isLoading: boolean;
  isProcessing: boolean;
  startSumSub: boolean;
  accessToken: string;
  sumSubDone: boolean;
}

class SubscriptionTabSumSubComponent extends React.Component<SubscriptionTabSumSubComponentProps, SubscriptionTabSumSubComponentState> {

  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    try {
      const response = await RegisterService.getKycAccessToken(this.props.activeCompanyId);

      this.setState({
        accessToken: response,
        isLoading: false
      });
    } catch (e) {
      console.error(e);
      NotificationHelper.createNotification(NotificationHelper.TYPE_ERROR);
    }
  }

  submitForm = async () => {
    if (!this.validateDocuments()) return;
    this.setState({ isProcessing: true });

    // add documents
    const addPromises = [];

    // if nothing, do nothing
    if (addPromises.length === 0) {
      this.props.successHandler();
      return;
    }

    try {
      await Promise.all(addPromises);
      this.props.successHandler();
    } catch (e) {
      handleApiFormResponse.call(this, e);
      this.setState({ isProcessing: false });
    }
  }

  accessTokenExpirationHandler = async () => {
    return;
  }

  startSumSub = () => {
    this.setState({ startSumSub: true });
  }

  messageHandler = async (message, payload) => {
    // console.log(message);
    // console.log(payload);
    if (this.state.sumSubDone)
      return;
    if (message == 'idCheck.onApplicantStatusChanged') {
      if (payload.reviewStatus == 'completed' && (payload.reviewResult.moderationComment === null || payload.reviewResult.moderationComment === undefined || payload.reviewResult.moderationComment.includes("couldn’t verify your profile") == false)) {
        const response = await RegisterService.getPersonInfo(this.props.activeCompanyId);
        this.props.successHandler();
        this.setState({ sumSubDone: true })
      }
      if (payload.reviewStatus == 'completed' && payload.reviewResult.moderationComment && payload.reviewResult.moderationComment.includes("couldn’t verify your profile") == true)
        this.errorHandler();
    }
    return;
  }

  errorHandler = async () => {
    // console.log('error');
    // get person info will deal with incomplete kyc
    await RegisterService.setKyc(this.props.activeCompanyId);
    return;
  }

  render = () => {
    if (this.state.isLoading) return (<LoadingComponent />);
    if (this.state.startSumSub) return (
      <React.Fragment>
        <PageSubTitleViewComponent id="page.subscription.tabsumsub.h2" />
        <Box>
          <SumsubWebSdk
            accessToken={this.state.accessToken}
            expirationHandler={this.accessTokenExpirationHandler}
            config={
              { 'theme': 'light' }
            }
            // options={options}
            onMessage={this.messageHandler}
            onError={this.errorHandler}
          />
        </Box>
      </React.Fragment>)
    return (
      <React.Fragment>
        <PageSubTitleViewComponent id="page.subscription.tabsumsub.h2" />
        <Box p={2}>
          <Box>
            <IntlMessageComponent id="page.subscription.tabsumsub.explanation" /><br /><br />
            <IntlMessageComponent id="page.subscription.tabsumsub.explanation2" /><br /><br />
          </Box>

          <ButtonComponent
            color="primary"
            variant="contained"
            isProcessing={this.state.isProcessing}
            onClick={this.startSumSub}
          ><IntlMessageComponent id="page.subscription.tabsumsub.startkyc" /></ButtonComponent>
        </Box>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id,
  activeCompanyPersonId: state.auth.user.activeCompany.companyPersonId
});

export default connect(mapStateToProps)(SubscriptionTabSumSubComponent);
